import Utils from "../../../utility";

const initialState = {
  GRNList: [],
  GRNDetail: {},
  id: 0,
  type: "",
  order: "DESC",
  sortField: "",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  oprationManagerList: [],
  billerList: [],
  InvoiceGRNList: [],
  invoiceNumber:"",
  vendorName:"",
};
export const GRNReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.GRN}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
